import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Container } from '../../primitives/List/components/Container.js';
export const List = /*#__PURE__*/_styled(({
  as = 'ul',
  spacing = 'small',
  withIcons,
  children,
  ...restProps
}) => {
  return _jsx(Container, {
    ...restProps,
    as: as,
    spacing: spacing,
    withIcons: withIcons,
    role: "list",
    children: children
  });
}, {
  label: 'List',
  target: "ercyx9v0"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxpc3QuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBT0ciLCJmaWxlIjoiTGlzdC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4IH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi9wcmltaXRpdmVzL0xpc3QvY29tcG9uZW50cy9Db250YWluZXIuanMnO1xuZXhwb3J0IGNvbnN0IExpc3QgPSBzdHlsZWQoKHsgYXMgPSAndWwnLCBzcGFjaW5nID0gJ3NtYWxsJywgd2l0aEljb25zLCBjaGlsZHJlbiwgLi4ucmVzdFByb3BzIH0pID0+IHtcbiAgICByZXR1cm4gKF9qc3goQ29udGFpbmVyLCB7IC4uLnJlc3RQcm9wcywgYXM6IGFzLCBzcGFjaW5nOiBzcGFjaW5nLCB3aXRoSWNvbnM6IHdpdGhJY29ucywgcm9sZTogXCJsaXN0XCIsIGNoaWxkcmVuOiBjaGlsZHJlbiB9KSk7XG59LCB7XG4gICAgbGFiZWw6ICdMaXN0Jyxcbn0pIGBgO1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9TGlzdC5qcy5tYXAiXX0= */");